export const PAGINATED_WIDGETS = [
    'table',
    'key-findings',
    'open-ports',
    'findings-grid',
    'ad-all-users-table',
    'ad-inactive-users-table',
    'ad-all-computers-table',
    'ad-workstation-age-table',
    'ad-inactive-computers-table',
    'ad-groups-risk-table',
    'ad-ous-risk-table',
    'ad-fsmo-roles-table',
    'ad-gpo-analysis-table',
    'ad-users-audit-table',
    'ad-computers-audit-table',
    'ad-devices-audit-table',
    'ad-groups-audit-table',
    'ad-ous-audit-table',
    'ad-domain-controllers-audit-table',
    'ad-gpo-policies-audit-table',
    'ad-event-logs-audit-table',
    'ms365-scan-proof-table',
    'microsoft-policies-table',
    'localhost-hardware-information-table',
    'localhost-system-information-table',
    'localhost-installed-applications-table',
    'localhost-event-logs-table',
    'localhost-open-ports-audit-table',
    'network-backup-status-table',
    'network-os-versions-table',
    'network-firewall-status-table',
    'network-detailed-services-table',
    'network-non-default-services-table',
    'network-services-risk-breakdown-table',
    'network-high-privilege-services-table',
    'network-users-no-expiring-password-table',
    'network-users-expiring-password-table',
    'network-admins-no-expiring-password-table',
    'network-admins-expiring-password-table',
    'network-admins-daily-work-table',
    'network-sensitive-open-ports-table',
    'network-logical-disks-table',
    'ms365-inactive-users-table',
    'ms365-all-users-mfa-table',
    'ms365-users-without-mfa-table',
    'localhost-high-privilege-services-table',
    'network-antivirus-status-table',
    'network-encryption-status-table',
    'pii-detected-table',
    'software-inventory-table',
    'local-administrators-table',
    'ad-admins-table',
    'ms365-policy-config-table',
    'localhost-os-version-table',
    'localhost-os-versions-table',
    'localhost-sensitive-open-ports-table',
    'localhost-services-risk-breakdown-table',
    'localhost-non-default-services-table',
    'localhost-open-ports-table',
    'localhost-browser-passwords-table',
    'localhost-all-users-password-table',
    'localhost-non-expiring-passwords-table',
    'localhost-disk-usage-table',
    'localhost-installed-software-table',
    'network-all-open-ports-table',
    // External Risk Scan Tables
    'external-all-findings-table',
    'external-warnings-table',
    'external-passed-table',
    'external-compliance-table',
    'external-dns-findings',
    'external-email-findings',
    'external-ssl-findings',
    'external-headers-findings',
    'external-infrastructure-findings',
    'external-breach-findings'
];
